const ControlButton = ({ onClick, text }) => {
  return (
    <button
      className="bg-transparent hover:text-red text-red font-semibold m-1 py-2 px-4 border border-red rounded"
      onClick={onClick}
    >
      { text }
    </button>
  );
};

export default ControlButton;
